const CardIcon = ({ color }: any) => {
    return (
        <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.3333 0.666687H1.66665C0.926646 0.666687 0.33998 1.26002 0.33998 2.00002L0.333313 10C0.333313 10.74 0.926646 11.3334 1.66665 11.3334H12.3333C13.0733 11.3334 13.6666 10.74 13.6666 10V2.00002C13.6666 1.26002 13.0733 0.666687 12.3333 0.666687ZM11.6666 10H2.33331C1.96665 10 1.66665 9.70002 1.66665 9.33335V6.00002H12.3333V9.33335C12.3333 9.70002 12.0333 10 11.6666 10ZM12.3333 3.33335H1.66665V2.00002H12.3333V3.33335Z" fill="#206371" />
        </svg>
    )
}
export default CardIcon
